export default "__VITE_ASSET__23e83bad__"